module.exports = __webpack_public_path__ + "static/media/washing_machine_smoke.b34064a1.svg";